module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-EPI"
  }, [_vm._v("ALTHOUGH THE FOLLOWING ACCOUNT IS TRUE, THE NAMES OF CERTAIN PERSONS AND PLACES HAVE BEEN CHANGED IN THE INTEREST OF PRESERVING THEIR ANONYMITY AND PROTECTING MY OWN LIFE.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-EPIC"
  }, [_vm._v("S.W.F.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2c14fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fussell_Muscle_4P_MD4.vue
// module id = 72
// module chunks = 0